export const getDefaultValues = (wheelItemDetails) => ({
  WheelItemWheelItemTypeID: wheelItemDetails?.WheelItemTypeID || '',
  WheelItemLabel: wheelItemDetails?.WheelItemLabel || '',
  WheelItemDescription: wheelItemDetails?.WheelItemDescription || '',
  WheelItemImage: wheelItemDetails?.WheelItemImage || '',
  WheelItemPopupImage: wheelItemDetails?.WheelItemPopupImage || '',
  WheelItemQuantity: wheelItemDetails?.WheelItemQuantity || '',
  WheelItemProbability: wheelItemDetails?.WheelItemProbability || '',
  WheelItemOrder: wheelItemDetails?.WheelItemOrder || '',
  WheelItemReward: wheelItemDetails?.WheelItemReward,
  WheelItemTransactionAmountTypeID: wheelItemDetails?.WheelItemTransactionAmountTypeID,
});
